import { render, staticRenderFns } from "./MenuRouteCard.vue?vue&type=template&id=1157b453"
import script from "./MenuRouteCard.vue?vue&type=script&lang=js"
export * from "./MenuRouteCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports